export interface CachedCompany {
  data: any
  timestamp: number
  slug: string
  version: number
}

const COMPANY_CACHE = new Map<string, CachedCompany>()
const CACHE_DURATION = 30 * 60 * 1000 // 30 minutes - otimizado para melhor performance

export function getCachedCompany(slug: string, skipExpiry = false): any | null {
  const cached = COMPANY_CACHE.get(slug)
  if (!cached) return null
  
  // Permitir retornar cache expirado se skipExpiry = true (stale-while-revalidate)
  if (skipExpiry) return cached.data
  
  const isExpired = Date.now() - cached.timestamp > CACHE_DURATION
  if (isExpired) {
    return null
  }
  
  return cached.data
}

export function setCachedCompany(slug: string, data: any): void {
  if (!data || !data.id || !data.slug) {
    return;
  }
  
  COMPANY_CACHE.set(slug, {
    data,
    timestamp: Date.now(),
    slug,
    version: 1
  })
}

export function clearCompanyCache(): void {
  COMPANY_CACHE.clear()
}

export function removeCachedCompany(slug: string): void {
  COMPANY_CACHE.delete(slug)
}